export default Object.freeze({
	NotInResubmission: 'not_in_resubmission',
	PaymentResubmission: 'payment_resubmission',
	NonCorrectablePaymentResubmission: 'non_correctable_payment_resubmission',
});
